<template>
    <div class="content-wrapper">
        <div class="line" ref="line"></div>
        <!-- INTRO -->
        <div class="section-wrapper"> 
            <div class="section-block">
                <div class="text-wrapper">
                    <h6>the Planet's width:</h6>
                    <div class="bridgeDot bHollow"></div><div class="bridgeDot bRound"></div>
                    <p class="stat"><span>7920 Miles</span></p>
                    <br>
                    <h6>Life:</h6>
                    <div class="bridgeDot bRound"></div>
                    <p class="stat"><span>Exists on the outside</span></p>
                    <br>
                </div>
            </div>
        </div>
        <div class="image-wrapper image-1" ref="section1">
            <div class="image-text">
                <!-- UPDATE COORDS -->
                <article>46°33'01.4" N, 8°42'42.8" E</article>
                <article>Henry Xu</article>
            </div>
        </div>

        <!-- LAYERS OF THE EARTH -->
        <div class="section-wrapper">
            <div class="section-block">
                <div class="text-wrapper">
                    <!-- <div class="header-dot"></div> -->
                    <!-- <h6 class="section-header">Pieces of the Earth</h6>
                    <br>
                    <h6>Layers</h6>
                    <p class="stat"><span>The Crust</span></p>
                    <p class="stat"><span>The Mantle</span></p>
                    <p class="stat"><span>The Inner core</span></p>
                    <p class="stat"><span>The Inner core</span></p>
                    <br>
                    <h6>Observed</h6>
                    <p class="stat"><span>Monitoring the Earths forces</span></p> -->
                    <h6>Number of layers:</h6>
                    <div class="bridgeDot bHollow"></div><div class="bridgeDot bRound"></div>
                    <p class="stat"><span>Comprised of 4 layers.</span></p>
                    <br>
                    <h6>Layer movement:</h6>
                    <!-- <div class="bridgeDot bHollow"></div> -->
                    <p class="stat"><span>Unresolved.</span></p>
                </div>
            </div>
        </div>
        <div class="layers-section" ref="layerSectionWrapper">
            <div class="layers-graphic-wrapper" ref="layersGraphicWrapper">
                <div class="layer-graphic">
                    <div class="layers-wrapper">
                        <img src="../assets/graphics/codex_2/layers-1.svg" alt="" ref="layer1">
                        <img src="../assets/graphics/codex_2/layers-2.svg" alt="" ref="layer2">
                        <img src="../assets/graphics/codex_2/layers-3.svg" alt="" ref="layer3">
                        <img src="../assets/graphics/codex_2/layers-4.svg" alt="" ref="layer4">
                        <p class="layers-info-text" ref="layerText">9999.99</p>
                    </div>
                </div>
            </div>
            <div class="section-wrapper" ref="layer1text">
                <div class="section-block">
                    <div class="text-wrapper">
                        <h6>The Proximal:</h6>
                        <div class="bridgeDot bHollow"></div><div class="bridgeDot bRound"></div>
                        <p class="stat"><span>Made of mostly rock</span></p>
                    </div>
                </div>
            </div>
            <div class="section-wrapper" ref="layer2text">
                <div class="section-block">
                    <div class="text-wrapper">
                        <h6>The Molten:</h6>
                        <div class="bridgeDot bRound"></div>
                        <p class="stat"><span>Source of magma within the earth</span></p>
                        <!-- <p>This layer is sperated to us only by the crust and is responsible for the creation of diamonds.
                            It is thicker than the other layers, hot, semi-solid, and circulates. It is comprised 
                            of iron, magnesium and silicon making it denser than the crust. Towards the inner region 
                            of this layer, its temperaturesreach the melting point of rock. The mantle is thought 
                            to be <span>1,865 mi.</span> thick.
                        </p> -->
                    </div>
                </div>
            </div>
            <div class="section-wrapper" ref="layer3text">
                <div class="section-block">
                    <div class="text-wrapper">
                        <h6>The Distal:</h6>
                        <p class="stat"><span>Crust like layer casing</span></p>
                        <!-- <p>This layer is also made from iron and nickel but are constantly in a liquid state. The source of 
                            this layers temperature is attributed to the radioactive decay of uranium and thorium. 
                            This process causes the liquid to chrun in huge turbulent currents, generating electrical currents
                            which supply the <span>magnetic field</span>. The outer core is thought 
                            to be <span>1023.5</span> to <span>1,318.4 mi.</span> to thick.</p> -->
                    </div>
                </div>
            </div>
            <div class="section-wrapper" ref="layer4text">
                <div class="section-block">
                    <div class="text-wrapper">
                        <h6>Outer Ice Casing:</h6>
                        <p class="stat"><span>All other layers are encased by ice</span></p>
                        <!-- <p>The layer resides at the heart of the earth. It, like the outer core, also circulates but differs
                            by spinning faster and also reaching temperatures of 9,800°F; almost as hot as the Sun. 
                            It is mostly comprised of iron and nickel and features pressures over 3 million times greater
                            than the earth's surface. The inner core is thought to be <span>758 mi.</span> to thick.</p> -->
                    </div>
                </div>
            </div>
            <div class="section-wrapper pullw">
                <div class="section-block">
                    <div class="text-wrapper pulltw">
                        <div class="pull-quote">
                            “Except for the crust, no one has ever explored these layers in person. In fact, the deepest humans have ever drilled is just over 7.6 miles!”
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="image-wrapper image-2" ref="section2">
            <div class="image-text">
                <article>25°41'43.1" S, 54°26'12.0" W</article>
                <article>Bantersnaps</article>
            </div>
        </div>

        <!-- MAGNETIC FIELD -->
        <div class="section-wrapper graphic-next">
            <div class="section-block">
                <div class="text-wrapper">
                    <h6>Field path:</h6>
                    <div class="bridgeDot bHollow"></div><div class="bridgeDot bRound"></div>
                    <p class="stat"><span>Helical</span></p>
                    <br>
                    <h6>Number of fields:</h6>
                    <div class="bridgeDot bRound"></div>
                    <p class="stat"><span>1</span></p>
                </div>
            </div>
        </div>
        <div class="section-block">
            <div class="graphic-block">
                <div class="mag-field-wrapper">
                    <img src="../assets/graphics/codex_2/full-mag-field.svg" alt="">
                </div>
            </div>
        </div>
        <div class="section-wrapper graphic-prev">
            <div class="section-block">
                <div class="text-wrapper">
                    <!-- <h6>Changes over time</h6> -->
                    <p>By early 2018, the World Magnetic Model was in trouble. Researchers from NOAA and the British Geological Survey in Edinburgh had been doing their annual check of how well the model was capturing all the variations in Earth’s magnetic field. They realized that it was so inaccurate that it was about to exceed the acceptable limit for navigational errors.</p>
                </div>
            </div>
        </div>
        <div class="section-wrapper pull">
                <div class="section-block">
                    <div class="text-wrapper">
                        <div class="pull-quote">
                            “The North pole wanders in unpredictable ways that have fascinated explorers and scientists since James Clark Ross first measured it in 1831."
                        </div>
                    </div>
                </div>
            </div>
        <div class="image-wrapper image-3" ref="section3">
            <div class="image-text">
                <article>19°19'21.0" N, 155°01'57.8" W</article>
                <article>Samuel Scrimshaw</article>
            </div>
        </div>

        <!-- TECTONIC PLATES -->
        <div class="section-wrapper graphic-next">
            <div class="section-block">
                <div class="text-wrapper">
                    <h6>Number of major plates</h6>
                    <div class="bridgeDot bRound"></div>
                    <p class="stat"><span>6</span></p>
                    <br>
                    <h6>Movement</h6>
                    <div class="bridgeDot bRound"></div>
                    <p class="stat"><span>Drift across the molten layer</span></p>
                    <br>
                    <h6>Speed</h6>
                    <div class="bridgeDot bRound"></div>
                    <p class="stat"><span>1 to 2 in. per year</span></p>
                </div>
            </div>
        </div>
        <div class="graphic-block tectonic">
            <img src="../assets/graphics/codex_1/full-tectonic-plates.svg" alt="">
        </div>
        <div class="section-wrapper graphic-prev">
            <div class="section-block">
                <div class="text-wrapper">
                    <!-- <h6>A spin on plates</h6> -->
                    <p>Plate tectonics is a scientific theory describing the large-scale motion of seven large plates and the movements of a larger number of smaller plates of the Earth’s lithosphere, since tectonic processes began on Earth between 3.3 and 3.5 billion years ago. The model builds on the concept of continental drift, an idea developed during the first decades of the 20th century.</p>
                    <!-- <p>There are a few handfuls of major plates and dozens of smaller, or minor, plates. Six of the majors are named for the continents embedded within them, such as the North American, African, and Antarctic plates. Though smaller in size, the minors are no less important when it comes to shaping the Earth. The plates make up Earth’s outer shell, called the lithosphere. They move at a rate of one to two inches (three to five centimeters) per year.</p> -->
                </div>
            </div>
        </div>
        <div class="section-wrapper pull">
                <div class="section-block">
                    <div class="text-wrapper">
                        <div class="pull-quote">
                            "The view of continental drift gained support and a lively debate started between 'drifters' and 'fixists'."
                        </div>
                    </div>
                </div>
            </div>
        <div class="image-wrapper image-4" ref="section4">
            <div class="image-text">
                <article>XXX°XX'XX.X" X, XXX°XX'XX.X" X</article>
                <article>Artur D</article>
            </div>
        </div>

        <!-- THE EARTH A SPHERE -->
        <div class="section-wrapper graphic-next">
            <div class="section-block">
                <div class="text-wrapper">
                    <!-- <div class="header-dot"></div> -->
                    <h6>Shape of "Flat" Earth</h6>
                    <p class="stat"><span>A disc</span></p>
                    <br>
                    <h6>Revolution</h6>
                    <p class="stat"><span>The Sun revolves above the crust</span></p>
                    <br>
                    <h6>Equator</h6>
                    <p class="stat"><span>Midway point between center and edge</span></p>
                    <br>
                    <!-- <p>The Earth as a round shape was unearthed by the ancient Greeks; Pythagoras
                        first proposed this sentiment in 500 B.C. He came to this conclusion by observing the shape of
                        the Moon's terminator, or the line between the light part of the Moon and the dark part of the Moon.
                        He reasoned that if the Moon was round, then the Earth must be round as well.
                    </p> -->
                </div>
            </div>
        </div>
        <div class="section-block">
            <div class="graphic-block">
                <div class="sphere-wrapper">
                    <img src="../assets/graphics/codex_1/full-sphere.svg" alt="">
                </div>
            </div>
        </div>
        <div class="section-wrapper graphic-prev">
            <div class="section-block">
                <div class="text-wrapper">
                    <!-- <h6>A point in time</h6> -->
                    <p>The Earth as a round shape was unearthed by the ancient Greeks; Pythagoras observed the shape of
                        the Moon's terminator, and determined then the Earth must be round as well. Anaxagoras compared the earth's shadow 
                        on the Moon during a lunar eclipse it was also concluded so. And finally, Aristotle also declared that the Earth is 
                        a sphere based on observations he made of the constellations closer and further from the Earth's equator.
                    </p>
                    <!-- <p>Pyhagoras' thought was further explained by the work of Anaxagoras sometime between 500 B.C. and 430 B.C.; by comparing the earth's shadow on the Moon during a lunar
                        eclipse it was also concluded the Earth is round. And finally in 350 B.C. Aristotle also declared that the Earth is a sphere based on observations he made of the constellations
                        closer and further from the Earth's equator</p> -->
                </div>
            </div>
        </div>

        <!-- CONTINUE -->
        <h6 class="button-header">"The Earth is..."</h6>
        <div class="button-wrapper">
            <div class="button round" ref="roundButton2">"Round"</div>
            <div class="button flat" ref="flatButton2">"Flat"</div>
            <div class="button hollow" ref="hollowButton2">"Hollow"</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Content',
    methods: {
        round() {
            this.$emit('changeComponent', 1);
        },
        flat(){
            this.$emit('changeComponent', 2);
        },
        hollow(){
            this.$emit('changeComponent', 3);
        },
        handleScroll() {
            var winHeight = window.innerHeight;
            // var docHeight = document.documentElement.scrollHeight;
            var section1pos = this.$refs.section1.getBoundingClientRect();
            var section2pos = this.$refs.section2.getBoundingClientRect();
            var section3pos = this.$refs.section3.getBoundingClientRect();
            var section4pos = this.$refs.section4.getBoundingClientRect();
            // var scrollPos = window.scrollY;
            var imageMargin = winHeight * .04;
            // var halfImagePos = winHeight * .92;

            // Nav Text Changer
            if (section1pos.top > imageMargin) {
                this.$emit('changeNavText', '');
            }
            if (section1pos.top <= imageMargin && section2pos.top > imageMargin) {
                this.$emit('changeNavText', 'The Layers');
            }

            if (section2pos.top <= imageMargin && section3pos.top > imageMargin) {
                this.$emit('changeNavText', 'The Magnetic Field');
            }

            if (section3pos.top <= imageMargin && section4pos.top > imageMargin) {
                this.$emit('changeNavText', 'The Tectonic Plates');
            }

            if (section4pos.top <= imageMargin) {
                this.$emit('changeNavText', 'The Sphere');
            }

                // Layer 1
            var layer1textpos = this.$refs.layer1text.getBoundingClientRect().top;
            var halflayer1post = (this.$refs.layer1text.getBoundingClientRect().height / 2) + 200;
            var change1Here = halflayer1post - winHeight/2 + 400;
            if (change1Here >= layer1textpos) {
                this.$refs.layer1.style.opacity = "1";
                this.$refs.layerText.style.opacity = "1";
                this.$refs.layerText.innerHTML = "18.6 - 43.5 mi."
            } else {
                this.$refs.layer1.style.opacity = "0";
                this.$refs.layerText.style.opacity = "0";
            }
                // Layer 2
            var layer2textpos = this.$refs.layer2text.getBoundingClientRect().top;
            var halflayer2post = (this.$refs.layer2text.getBoundingClientRect().height / 2) + 200;
            var change2Here = halflayer2post - winHeight/2 + 350;
            if (change2Here >= layer2textpos) {
                this.$refs.layer2.style.opacity = "1";
                this.$refs.layerText.innerHTML = "1865 mi."
            } else {
                this.$refs.layer2.style.opacity = "0";
            }

                // Layer 3
            var layer3textpos = this.$refs.layer3text.getBoundingClientRect().top;
            var halflayer3post = (this.$refs.layer3text.getBoundingClientRect().height / 2) + 200;
            var change3Here = halflayer3post - winHeight/2 + 350;
            if (change3Here >= layer3textpos) {
                this.$refs.layer3.style.opacity = "1";
                this.$refs.layerText.innerHTML = "1023.5 - 1318.4 mi."
            } else {
                this.$refs.layer3.style.opacity = "0";
            }

                // Layer 4
            var layer4textpos = this.$refs.layer4text.getBoundingClientRect().top;
            var halflayer4post = (this.$refs.layer4text.getBoundingClientRect().height / 2) + 200;
            var change4Here = halflayer4post - winHeight/2 + 350;
            if (change4Here >= layer4textpos) {
                this.$refs.layer4.style.opacity = "1";
                // this.$refs.layerText.style.color = "#F0F4F8";
                // this.$refs.layerText.style.backgroundColor = "transparent";
                this.$refs.layerText.innerHTML = "758 mi."
            } else {
                this.$refs.layer4.style.opacity = "0";
                this.$refs.layerText.style.color = "#212121";
                this.$refs.layerText.style.backgroundColor = "#F0F4F8";
            }

            var textChange = this.$refs.layer4text.getBoundingClientRect().bottom - halflayer4post;
            if (textChange <= 100) {
                this.$refs.layerText.style.opacity = "0";
            }
            
        },
        wrapperHeight() {
            // Graphic Wrapper is length of content + half of image
                var section2pos = this.$refs.section2.getBoundingClientRect();
                var wrapperHeight = this.$refs.layerSectionWrapper.getBoundingClientRect().height;
                var idealWrapperHeight = wrapperHeight + section2pos.height/2 - 75;
                this.$refs.layersGraphicWrapper.style.height = idealWrapperHeight + "px";

            // Set height of line to continue until magnetic field
            // NEED TO DO
        }

    },
    created() {
        // this.handleScroll();
        this.$emit('contentListener', '2');
    },
    mounted () {
        window.addEventListener('resize', this.wrapperHeight);
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
        this.wrapperHeight();
        this.$refs.roundButton2.addEventListener("click", this.round);
        this.$refs.flatButton2.addEventListener("click", this.flat);
        this.$refs.hollowButton2.addEventListener("click", this.hollow);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.wrapperHeight);
        window.removeEventListener('scroll', this.handleScroll);
    }
    
}
</script>

<style scoped>
    * {
        user-select: none;
    }

    .content-wrapper {
        /* height: 500vh; */
        width: 100%;
        /* background-color: red; */
        position: relative;
        padding-top: 20vh;
        margin-top: 50px;
    }

    .line {
        position: absolute;
        right: 12vw;
        top: 0;
        height: calc(100% + 20vh);
        width: 1px;
        background-color: #212121;
        z-index: 9;
    }

    .section-wrapper {
        width: 100%;
        /* min-height: 70vh; */
        padding-top: 200px;
        padding-bottom: 200px;
    }

    .graphic-next {
        padding-bottom: 150px !important;
    }

    .graphic-prev {
        padding-top: 150px !important;
    }

    .pull {
        padding-top: 100px !important;
        text-indent: -30px;
    }

    .line + .section-wrapper {
        padding-top: 0px !important;
    }

    .section-block {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        /* background-color: pink; */
        position: relative;
        /* height: 500px; */
    }

    .graphic-block {
        height: 300px;
        width: 100%;
        /* background-color: red; */
        position: relative;
    }

    .tectonic {
        height: 400px !important;
        /* width: calc(100% - 20vw) !important; */
    }

    .tectonic img {
        height: 100%;
    }

    .mag-field-wrapper {
        position: absolute;
        right: calc(12vw - 250px); 
        height: 300px;
        width: 500px;
    }

    .sphere-wrapper {
        position: absolute;
        right: calc(12vw - 150px); 
        height: 300px;
        width: 300px;
    }

    .header-dot {
        position: absolute;
        right: calc(12vw - 30px);
        top: -20px;
        height: 60px;
        width: 60px;
        border-radius: 50%;
        background-color: #459300;
        border: 1px solid #212121;
        box-sizing: border-box;
        z-index: 9;
    }

    h6 {
        font-family: odisseia, sans-serif;
        text-transform: uppercase;
        font-weight: 900;
        font-size: 20px;
        /* margin: 0px 0px 7px 0px; */
        margin: 0;
    }

    .section-header {
        font-size: 36px;
        color: #459300;
    }

    .text-wrapper {
        width: calc(100% - 30vw);
    }

    /* .pulltw {
        width: calc(100% - 30vw);
    } */

    p {
        font-family: roboto, sans-serif;
        font-size: 20px;
        line-height: 32px;
        /* width: calc(100% - 30vw); */
        /* margin: 0; */
        margin: 2px 0px 2px 0px;
        letter-spacing: .5px;
    }

    span {
        /* font-family: odisseia, sans-serif; */
        /* font-weight: 900; */
        /* text-transform: uppercase; */
        font-size: 24px;
        margin: 2px 0px 2px 0px;
        /* line-height: 32px; */
        letter-spacing: 1px;
        /* color: #2D7BE5; */
    }

    .stat {
        /* margin-top: -5px; */
        /* line-height: 12px; */
        margin-left: 20px;
    }

    .button {
        bottom: calc(0px - 40vh - 25px);
    }

    .pull-quote {
        /* width: calc(100% - 30vw); */
        font-family: odisseia, sans-serif;
        font-weight: 900;
        font-size: 51px;
        line-height: 71px;
        color: #459300;
        margin: 0;
        text-transform: uppercase;
    }

    .image-wrapper {
        position: relative;
        left: -220px;
        height: 92vh;
        width: calc(100% + 220px + 79px);
        /* background: yellow; */
        position: relative;
        overflow: hidden;
    }

    .image-text {
        font-family: odisseia, sans-serif;
        font-size: 10px;
        color: #F0F4F8;
        text-transform: uppercase;
        /* color: red; */
        margin: 0;
        opacity: .80;
        transform: rotate(-90deg) translateY(-240%) translateX(-50%);
        transform-origin: middle;
        position: absolute;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        white-space: nowrap;
        align-items: flex-end;
        top: 0;
        left: 0;
        user-select: none;
    }

    .image-1 {
        background-image: url("../assets/images/flat-lake-henry-xu.jpg");
        background-size: cover;
        background-position: top center;
    }

    .image-2 {
        background-image: url("../assets/images/flat-ice-bantersnaps.jpg");
        background-size: cover;
        background-position: top center;
    }

    .image-3 {
        background-image: url("../assets/images/flat-ground-samuel-scrimshaw.jpg");
        background-size: cover;
        background-position: top center;
    }

    .image-4 {
        background-image: url("../assets/images/flat-ice-artur-d.jpg");
        background-size: cover;
        background-position: top center;
    }

    .layers-section {
        /* background-color: teal; */
        position: relative;
    }

    .layers-graphic-wrapper {
        /* height: calc(100% - 550px); */
        width: 300px;
        /* position: sticky; */
        position: absolute;
        top: 200px;
        box-sizing: border-box;
        /* padding: 200px 0px; */
        right: calc(12vw - 150px); 
        /* right: 12vw; */
        /* background-color: red; */
        z-index: 9;

    }

    .layers-info-text {
        font-family: odisseia, sans-serif;
        font-size: 10px;
        /* color: #F0F4F8; */
        /* text-transform: uppercase; */
        /* color: red; */
        /* margin: 0; */
        /* opacity: .80; */
        /* transform-origin: middle; */
        position: absolute;
        white-space: nowrap;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        user-select: none;
        width: 120px;
        opacity: 0;
        text-align: center;
        background-color: #F0F4F8;
        color: #212121;
        transition: opacity .3s ease-in-out, background-color .2s ease-in-out;
    }

    .layer-graphic {
        height: 300px;
        width: 300px;
        /* background-color: black; */
        /* border-radius: 50%; */
        top: calc(50% - 150px);
        position: sticky;
        /* background-image: url("../assets/graphics/codex_1/full-layers.svg"); */
    }

    .layers-wrapper {
        /* background-color: green; */
        height: 100%;
        width: 100%;
        position: relative;
    }

    .layers-wrapper img {
        opacity: 0;
        height: 100%;
        width: 100%;
        position: absolute;
        transition: opacity .4s ease-in-out;
    }

    .active {
        opacity: 1;
    }

</style>